export default {
  tips: {
    google: 'google验证器未绑定，请前往绑定',
    tip: '不是商户，不能提现'
  },
  label: {
    withdrawalAmountTotal: '提现金额总计',
    handlingFeeTotal: '提现手续费总计',
    agentNo: '代理账号',
    account: '账号姓名',
    actualTransferAmount: '实际到账金额',
    bankName: '银行名称',
    bankNo: '银行卡号',
    bankCode: "银行编码",
    createAcct: '创建人',
    createTime: '创建时间',
    operatorName:'代付通道',
    handlingFee: '手续费',
    agentFee: "代理费用",
    bankLoginAccount: '银行登陆账号',
    bankLoginPwd: '银行登陆密码',
    merchatName: '商户名称',
    asyncStatus: {
      label: "通知状态",
      status: {
        "0": "未通知",
        "1": "通知成功",
        "-1": "通知失败"
      }
    },
    payoutFeeCount: "代付手续费总计",
    payoutAmountCount: "代付金额总计",
    receiver: "收款人",
    paymentBank: "付款银行",
    paymentName: "付款人",
    paymentAccount: "付款账号",
    applyTime: "申请时间",
    notifyTime: "通知时间",
    id: '主键id',
    merchatNo: '商户号',
    remark: '备注',
    reviewer: '审核人',
    type: '类型',
    updateAcct: '更新人',
    updateTime: '更新时间',
    withdrawalAmount: '提现申请金额',
    withdrawalNo: '提现订单号',
    withdrawalStatus: '状态',
    action: '操作',
    totalBalance: '代付可用总余额',
    payoutSumAmount: '代付总出款',
    systemOrderNo: "系统订单号",
    amount: "代付金额",
    accountBankCode: "出款银行编码",
    accountNumber: "出款账号",
    accountName: "出款人名称",
    description: "内容",
    beneficiaryName: "收款人名称",
    payTime: "支付时间",
    payAmount: "成功金额",
    cashType: {
      label: "资金类型",
      status: [
        { label: "转入", value: "+" },
        { label: "转出", value: "-" },
      ]
    },
    orderNo: "商户订单号",
    merchantNo: "所属商户号",
    merchantName: "所属商户名称",
    payoutType1:"自动代付",
    payoutType2:"手动代付",
    paymentType:"代付类型",
    paymentFixedFeeTatal:'代付固定手续费总计',
    autoSuccessAmount:'自动成功金额',
    manualSuccessAmount:'补单成功金额',
  },
  rules: {
    bankNo: {
      required: '银行卡号不能为空',
      type: '银行卡号必须为数字',
      min: '银行卡号长度必须大于等于9'
    },
    bankName: {
      required: '银行名称不能为空',
    },
    depositor: {
      required: '银行账户持有人不能为空',
    },
    cardNumber: {
      required: '银行卡号不能为空',
    },
    bankCode: {
      required: '银行编码不能为空',
    },
    loginName: {
      required: '银行登陆用户名不能为空',
    },
    otp: {
      required: '请输入6到8位的交易码',
    },
  },
  orderDescription: '订单描述',
  withdrawalInterval: '出款间隔',
  bankInfo_label1: '日限制代付次数',
  bankInfo_label2: '代付最小金额',
  bankInfo_label3: '代付最大金额',
  bankInfo_label4: '日累计代付次数',
  batchSettings: '批量设置'
};



// WEBPACK FOOTER //
// ./src/i18n/lang/zh/withdraw.js